module.exports = __webpack_public_path__ + "img/civilization_pact.4c16ef74.png";